import React from 'react';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

interface Props {
  color: 'primary' | 'secondary';
}

export const ArrowRightIcon = ({ ...props }: Props) => {
  let svgColor = 'blue';
  switch (props.color) {
    case 'secondary':
      svgColor = 'orange';
      break;
  }

  const path = `/images/icon/arrow-right-${svgColor}.svg`;
  return (
    <Span>
      <ReactSVG src={path} />
    </Span>
  );
};

export const ArrowLeftIcon = ({ ...props }: Props) => {
  let svgColor = 'blue';
  switch (props.color) {
    case 'secondary':
      svgColor = 'orange';
      break;
  }

  const path = `/images/icon/arrow-left-${svgColor}.svg`;
  return (
    <Span>
      <ReactSVG src={path} />
    </Span>
  );
};

const Span = styled.span`
  font-size: 0;
`;
export default ArrowRightIcon;
